const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
const isDark =
  localStorage.theme === "dark" ||
  (!("theme" in localStorage) && mediaQuery.matches);

toggleDarkTheme(isDark);

mediaQuery.addEventListener("change", (event) => {
  toggleDarkTheme(event.matches);
});

function toggleDarkTheme(isOn: boolean): void {
  document.documentElement.classList.toggle("dark", isOn);
  document.documentElement.style.colorScheme = isOn ? "dark" : "light";
}
